<template slot-scope="props">
  <div id="NewGroupManager">
    <b-container id="NewGroupManager__container">
      <b-row id="Top" class="p-4">
        <b-col align-self="center" xl="3" lg="6" md="6">
          <h1>Add Group Manager</h1>
        </b-col>
        <b-col align-self="center" xl="4" lg="6" md="6">
          <b-progress
            id="progress-bar"
            :value="value"
            :max="max"
            class="mb-3"
          ></b-progress>
        </b-col>
      </b-row>
      <form-wizard ref="wizard" id="" title="" subtitle="">
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3>Add Group Manager</h3>
              <div class="img__container">
                <img
                  src="../../../public/img/icons/wizard-icon-add.png"
                  class="img-fluid"
                />
              </div>
            </b-col>
            <b-col class="right-content pl-2" cols="8">
              <b-row class="buttons__container">
                <b-col class="mb-5 d-flex justify-content-end">
                  <a
                    :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !nextButtonAvailable }]"
                    @click="goNext()"
                  >
                  {{ nextButtontext }} <font-awesome-icon icon="angle-right" />
                  </a>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group id="area_name-group">
                      <div class="input-wrapper">
                        <div>
                          <label for="area_name" class="mb-3"><b>Assign area name</b><span class="ml-2" >|</span></label>
                          <b-button class="add-org-area-btn ml-3" variant="outline-dark" squared @click="toggleCreateAreaDropdown()">
                            + Create New Area
                          </b-button>
                          <div class="float-right" v-if="createAreaDropdown">
                            <b-form inline>
                              <label for="area_name" class="mr-2" >Area name: </label>
                              <b-form-input
                                class="mb-2 mr-sm-2 mb-sm-0 area-name-input"
                                :required="true"
                                id="area_name"
                                name="area_name"
                                v-model="$v.createAreaForm.name.$model"
                              />
                              <b-button class="area-name-input-btn" variant="success" size="sm" @click="createNewArea()">&#x2713;</b-button>
                              <b-button  variant="danger" size="sm" class="ml-2 area-name-input-btn" @click="toggleCreateAreaDropdown()">&#x10102;</b-button>
                            </b-form>
                          </div>
                        </div>
                        <b-form-select
                          id="area_name"
                          name="area_name"
                          v-model="$v.form.area_id.$model"
                          :options="[{ value: '', text: 'Please select an area', disabled: true }, ...existingAreaOptions]"
                          :state="validateState('area_id')"
                        />
                        <b-form-invalid-feedback id="area_name-invalid">
                          This field is required
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                    <b-form-group id="create__error-group">
                      <b-form
                        id="create_error-invalid"
                        class="invalid-feedback"
                        style="display: block"
                        v-if="apiErrors.ADD_GROUP_MANAGER"
                      >
                        {{ apiErrors.ADD_GROUP_MANAGER }}
                      </b-form>
                    </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="help-text__container">
                    <p>
                      <span>Assign new area:</span> Click on "Create New Area".
                    </p>
                    <p>
                      <span>Select an existing area:</span> Select from drop-down menu.<br>Multiple area names can be created for future use.
                    </p>
                    <p>
                      <span>Examples:</span> Area names might be Finance, Marketing, Training, Human Resources.<br>
                      The group manager you assign will create groups under this area.
                    </p>
                    <p>
                      <span>Group Manager Example:</span>
                      <br>
                      <img src="/img/group-managers/org_structure.png" class="mt-3"/>
                    </p>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3>Customize Invitation</h3>
              <div class="img__container">
                <img
                  src="../../../public/img/icons/wizard-icon-describe.png"
                  class="img-fluid"
                />
              </div>
            </b-col>
            <b-col class="right-content" cols="8">
              <b-row class="buttons__container">
                <b-col class="mb-5 d-flex justify-content-end">
                  <a
                    class="back-button"
                    @click="goBack()"
                    v-if="this.active_tab > 0"
                  >
                    <font-awesome-icon icon="angle-left" />
                    BACK
                  </a>
                  <a
                    :class="['TMGeneralButton', 'blue', 'presentation-button']"
                    @click="goNext()"
                  >
                  {{ nextButtontext }} <font-awesome-icon icon="angle-right" />
                  </a>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="invitation-message">
                  <label for="welcome_message">Invitation message (You can personalize your message)</label>
                  <b-form-textarea
                    id="welcome_message"
                    rows="8"
                    v-model="invitationMessage"
                  >
                  </b-form-textarea>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3 class="shrink-width">Invite manager two ways</h3>
              <div class="img__container">
                <img
                  src="../../../public/img/icons/wizard-icon-share.png"
                  class="img-fluid"
                />
              </div>
            </b-col>
            <b-col class="right-content" cols="8">
              <b-row class="buttons__container">
                <b-col class="mb-5 d-flex justify-content-end">
                  <a
                    class="back-button"
                    @click="goBack"
                    v-if="this.active_tab > 0"
                  >
                    <font-awesome-icon icon="angle-left" />
                    BACK
                  </a>
                  <router-link
                    :to="{ name: route }"
                    :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !canGoToDash}]"
                    @click="goNext"
                  >
                  {{ nextButtontext }} <font-awesome-icon icon="angle-right" />
                  </router-link>
                </b-col>
              </b-row>
              <b-row>
                <div id="email-link">
                  <h3>Send by Your Personal Email</h3>
                  <p>
                    The invitation message will show up in your email
                  </p>
                  <a
                    id="email_button"
                    class="TMGeneralButton router-link-exact-active router-link-active blue"
                    :href="getMailtoText()"
                    @click="enableGoToDashboardButton()"
                  >
                    SEND EMAIL <font-awesome-icon icon="angle-right" />
                  </a>
                </div>
              </b-row>
              <b-row>
                <div id="send-link">
                  <h3>Send by a Link</h3>
                  <p>You need to create your own invitation message</p>
                  <a
                    id="link_button"
                    class="TMGeneralButton blue"
                    @click="copyToClipboard()"
                  >
                  COPY LINK <font-awesome-icon icon="angle-right" />
                  </a>
                </div>
              </b-row>
              <b-row>
                <div id="notify-me">
                  <label for="notify" id="notify-label">
                    <input type="checkbox" v-model="emailMe" @change="updateEmailNotification($event)" name="notify" id="notify">
                    Please email me when a group manager signs up
                  </label>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>
      </form-wizard>
    </b-container>
  </div>
</template>
<script>
import TMGeneralButton from "../../components/common/TMGeneralButton.vue";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import { getAuthorizationToken } from "@/services/utils";
import Api from "@/services/api";

const greaterThanZero = (value) => value > 0;

export default {
  components: { TMGeneralButton },
  name: "NewGroup",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        area_id: "",
      },
      createAreaForm: {
        name: "",
        organization_id: ""
      },
      invitationMessage: "",
      emailMe: true,
      active_tab: null,
      value: 33.333333333,
      max: 100,
      overall: true,
      nextButtontext: "INVITE MANAGER",
      nextButtonAvailable: false,
      canGoToDash: false,
      route: "",
      token: "",
      existingAreaOptions: [],
      createAreaDropdown: false
    };
  },
  validations: {
    form: {
      area_id: {
        required,
      },
    },
    createAreaForm: {
      name: { required }
    }
  },

  methods: {
    ...mapActions([
      "ADD_GROUP_MANAGER", 
      "UPDATE_GROUP_MANAGER", 
      "GENERATE_MANAGER_TOKEN",
      "CLEAR_GROUP_MANAGER",
      "UPDATE_GROUP_MANAGER_NOTIFICATION"
    ]),
    copyToClipboard(id = null) {
      this.route = "AdminGroups";
      this.canGoToDash = true;
      let fullURL = "";
      if (this.token) {
        id = this.token;

        let path = this.$router.resolve({
          name: "SignUpGroupManager",
          params: { id: this.token },
        }).href;

        fullURL = window.location.origin + path;
      }
      try {
        navigator.clipboard.writeText(fullURL);
      } catch (e) {
        throw e;
      }
    },
    getMailtoText() {
      var message = encodeURI(this.invitationMessage);
      var subject = "You have been invited to use TorchMetrics.";
      let fullURL = "";
      if (this.token) {
        let path = this.$router.resolve({
          name: "SignUpGroupManager",
          params: { id: this.token },
        }).href;
        fullURL = window.location.origin + path;
      }
      return `mailto:?subject=${subject}&body=${message}%0A%0A%0A${fullURL}`;
    },
    validate() {
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data.form, isValid);
      this.nextButtonAvailable = isValid;
      return isValid;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      this.validate();
      return $dirty ? !$error : null;
    },
    goNext() {
      if (this.nextButtonAvailable) {
        if (this.active_tab === null || this.active_tab === 0) {
          if(!this.group_manager){
            this.createGroupManager();
          }else{
            this.updateGroupManager();
          }
        } else if (this.active_tab === 1) {
          this.updateGroupManager(this.token === "");
        }
      }
    },
    goBack() {
      if (this.active_tab === 1) {
        this.nextButtonAvailable = true;
        this.nextButtontext = 'INVITE MANAGER';
        this.value = 33.333333333;
        this.$refs.wizard.prevTab();
        this.active_tab = this.$refs.wizard.activeTabIndex;
      }else if (this.active_tab === 2) {
        this.nextButtonAvailable = true;
        this.nextButtontext = `SEND INVITATION`;
        this.value = 66.6666666;
        this.$refs.wizard.prevTab();
        this.active_tab = this.$refs.wizard.activeTabIndex;
      }
    },
    enableGoToDashboardButton() {
      this.route = "AdminGroups";
      this.canGoToDash = true;
    },
    updateEmailNotification(event) {
      this.UPDATE_GROUP_MANAGER_NOTIFICATION(this.emailMe);
    },
    createGroupManager() {
      this.ADD_GROUP_MANAGER({
        area_id: this.form.area_id,
        organization_id: this.currentUser.organization_id
      })
        .then(() => {
          this.nextButtonAvailable = false;
          this.nextButtontext = "SEND INVITATION";
          this.value = 66.666666;
          this.$refs.wizard.nextTab();
          this.active_tab = this.$refs.wizard.activeTabIndex;
      });
    },
    updateGroupManager(generate_token = false) {
      this.UPDATE_GROUP_MANAGER({
        area_id: this.form.area_id,
        organization_id: this.currentUser.organization_id,
        invitation_message: this.invitationMessage !== this.group_manager.invitation_message ? this.invitationMessage : null,
      })
        .then(() => {
          if(generate_token) this.generateToken();
          this.nextButtontext = generate_token || this.active_tab === 1 ? "GO TO DASHBOARD" : "SEND INVITATION";
          this.nextButtonAvailable = false;
          this.value = generate_token || this.active_tab === 1 ? 100 : 66.666666;
          this.$refs.wizard.nextTab();
          this.active_tab = this.$refs.wizard.activeTabIndex;
      });
    },
    createNewArea() {
      Api()
        .post("/organization_areas", { 
            organization_id: this.createAreaForm.organization_id,
            name: this.createAreaForm.name,
         },
         {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(res => {
            this.$toasted.show(`New area "${res.data.name}" successfully created!`);
            this.existingAreaOptions.push({ value: res.data.id, text: res.data.name});
            this.toggleCreateAreaDropdown();
        })
        .catch(err => {
            this.$toasted.show('There was error creating new area.', {type: 'error'});
        });
    },
    generateToken() {
      this.GENERATE_MANAGER_TOKEN(this.group_manager.id)
        .then( res => {
          this.token = res.token;
        });
    },
    toggleCreateAreaDropdown() {
      this.createAreaDropdown = !this.createAreaDropdown;
    }
  },
  computed: {
    ...mapState(["apiErrors", "currentUser", "group_manager"]),
  },
  watch: {
    group_manager: function(value){
      if(value.invitation_message) this.invitationMessage = value.invitation_message;
    },
  },
  mounted() {
    this.CLEAR_GROUP_MANAGER();
    this.createAreaForm.organization_id = this.currentUser.organization_id;
    Api().get("organizations/get_organization_areas", {
      params: {
        id: this.currentUser.organization_id
      },
      headers: {
        Authorization: getAuthorizationToken(),
      },
    })
    .then(res => {
      var options = [];
      res.data.forEach(a => options.push({value: a.id, text: a.name}));
      this.existingAreaOptions = options;
    })
    .catch((err) => {
      console.log(err);
    });
  }
};
</script>
<style lang="less">
@import "../../assets/components/groupManager/newGroupManager.less";
</style>